<template>
<div class="progressbar" :class="{oth: ($route.query.oth === null)}">
  <div class="fillme" :style="{width: fillmewidth + '%'}">
  </div>
</div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    setbarwidth: null,
  },
  data() {
    return {
      disableAddressInput: false,
      fillmewidth: '0%',
    };
  },
  computed: {},
  methods: {},
  watch: {
    setbarwidth: {
      handler: function() {
        this.fillmewidth = this.setbarwidth;
      },
    },
  },
  created() {
    this.fillmewidth = this.setbarwidth;
  },
};
</script>

<style lang="scss" scoped>
.progressbar {
    width: calc(100% - 50px);
    height: 3px;
    background-color: #D4F1E5;
    position: absolute;
    bottom: 20px;

    @screen xl {
      width: calc(100% - 180px);
    }

    .fillme {
        height: 100%;
        background-color: #00AB55;
        margin: 0;
    }
}
.progressbar.oth {
    background-color: #c6e3ff;

    .fillme {
        background-color: #2c96ff;
    }
}
</style>
